module.exports = __webpack_public_path__ + "static/fibonacci-home-8bd256388df6f78e02bd0555292962dc.mp4";